export default {
  title: "Create your wallet",
  description: "You need to create a wallet to continue",
  button: "Create wallet",
  advantages: {
    title: "Advantages",
    biometric: {
      title: "Biometrics",
      description:
        "sign your transactions with your own biometrics (FaceID or fingerprint). You don't have to do anything else, it's that easy.",
    },
    multiDevice: {
      title: "Multi-device",
      description: "you can use your same HumanWallet account from any device, accessing with your same private key.",
    },
  },
  disadvantages: {
    title: "Disadvantages",
    selfCustody: {
      title: "Self-custody",
      description:
        "your private keys are only as secure as the provider where you store them (Apple, Google or a third party).",
    },
  },
  learnMore: "Learn more",
  learnMoreModal: {
    title: "HumanWallet",
    websiteLink: "humanwallet.io",
  },
  logoAlt: "HumanWallet Logo",
  checkbox:
    "I confirm that I understand that Antipartido is not responsible for storing my wallet's private key, being solely responsible for it",
  backButton: "Start over",
}
